import React from 'react'
import { Skeleton, TableCell, TableRow } from '@hub-la/shadcn'

export const InvoiceTableLoading: React.FC = () => {
  return (
    <TableRow>
      <TableCell className="py-2">
        <div className="flex gap-2">
          <Skeleton className="w-5 h-6" />
          <Skeleton className="w-[62px] h-6" />
        </div>
      </TableCell>
      <TableCell className="py-2">
        <Skeleton className="w-11 h-6" />
      </TableCell>
      <TableCell className="py-2">
        <Skeleton className="w-[30%] h-6" />
      </TableCell>
    </TableRow>
  )
}
